import { useSetAtom } from "jotai";
import { useStoreState } from "atoms/storeAtom";
import {
  setConfirmationModalAtom,
  setModalCloseAtom,
} from "atoms/modalAtom/modalAtom";

import { Button } from "components/Button/Button";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";

import { useDeleteStore } from "../api";

export const StocksFooter = (): JSX.Element => {
  const setConfirmation = useSetAtom(setConfirmationModalAtom);
  const closeModal = useSetAtom(setModalCloseAtom);
  const { storeState, setStoreState } = useStoreState();

  const { mutate: deleteStore } = useDeleteStore();

  const onConfirm = () => {
    deleteStore(storeState.activeItem.storesid);

    closeModal();
  };

  const handleDeleteClick = () => {
    if (storeState.activeItem) {
      setConfirmation({
        title: "Вы действительно хотите удалить склад/магазин?",
        onConfirm,
      });
    }
  };

  const handlePlusClick = () => {
    setStoreState({ activeItem: null });
  };

  return (
    <>
      <div className="flex flex-row justify-between items-center">
        <div className="flex flex-row justify-between items-center">
          <Button icon="plus" onClick={handlePlusClick} />
          <HorizontalSpace size={11} />
          <Button onClick={handleDeleteClick} icon="delete" />
        </div>
      </div>
    </>
  );
};
